export function formatDateTime(iso: string): string {
  return new Date(iso).toLocaleString(undefined, {
    weekday: "short",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

// DOB comes from Postgres as "YYYY-MM-DD". Parse the components directly
// instead of new Date(...) — constructing a Date from "YYYY-MM-DD" treats
// it as UTC midnight and shifts by a day in negative-offset timezones.
export function formatDob(iso: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  if (!m) return iso;
  return `${m[2]}/${m[3]}/${m[1]}`;
}
